<template>
  <b-row>
    <b-col>
      <div style="display:table;margin:0 auto;">
        <div class="avatarbox mb-2">
          <b-img v-if="item.avatarPreview" :src="item.avatarPreview" alt="avatar"/>
          <img v-else src="/static/img/default-avatar.png" alt="user avatar"/>
        </div>
        <b-btn style="display:table;margin:0 auto;" @click="openChangeAvatarModal()">{{$t('views.userdata.show.changeAvatar')}}</b-btn>
      </div>
      <ChangeAvatarModal v-model="avatarChanged"></ChangeAvatarModal>
    </b-col>
  </b-row>
</template>

<script>
import ChangeAvatarModal from '../ChangeAvatarModal/ChangeAvatarModal'
import { checkPermission } from '@/utils/checkRoles.js'

export default {
  name: 'AvatarDisplay',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ableToEditUser () {
      return this.checkRoles('userdatas', 'UserUpdate')
    }
  },
  data () {
    return {
      avatarChanged: 0
    }
  },
  watch: {
    avatarChanged: function () {
      if (this.avatarChanged === 1) {
        this.$emit('input', 1)
        this.avatarChanged = 0
      }
    }
  },
  components: {
    ChangeAvatarModal
  },
  methods: {
    openChangeAvatarModal () {
      this.$store.state.modals.userdata.changeAvatar.show = 1
      this.$store.state.modals.userdata.changeAvatar.userData = this.item
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
